import CancellationPoliciesRedesign from './CancellationPoliciesRedesign';

export default CancellationPoliciesRedesign;
